<script>
  import InfoCard from './info-card.svelte';
  //colors: Primary(#4e73df),Success(#1cc88a),Info(#36b9cc),Warning(#f6c23e),Danger(#e74a3b),Secondary(#858796),Light(#f8f9fc),Dark(#5a5c69)
  export let color = 'primary';
  export let title;
  export let ico;
  export let value = 0;

  let textValue;
  let percent;

  function updateValues() {
    textValue = new Intl.NumberFormat('es-ES', {style: 'percent'}).format(value);
    percent = 100 * value;
  }

  $: value, updateValues();
</script>

<InfoCard color="{color}" title="{title}" ico="{ico}">
    <div class="row no-gutters align-items-center">
        <div class="col-auto">
            <div class="h5 mb-0 mr-3 font-weight-bold text-gray-800">{textValue}</div>
        </div>
        <div class="col">
            <div class="progress progress-sm mr-2">
                <div class="progress-bar bg-info" role="progressbar"
                     style="width: {percent}%" aria-valuenow="50" aria-valuemin="0"
                     aria-valuemax="100"></div>
            </div>
        </div>
    </div>
</InfoCard>
